import { Feed } from "./components/Feed";
import "./index.css";

export function App() {
  return <Feed />;
}

export default App;
